import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  	palette: {
    	primary: { main: '#000000'},
    	secondary: { main: '#f32c2c'},
  	}
});

export default theme;


// WEBPACK FOOTER //
// ./src/theme.js